import { useEffect, useRef, useState } from 'react'
// @mui material components
import Card from '@mui/material/Card'
import Modal from '@mui/material/Modal'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

// Material Dashboard 2 PRO React examples
import MDAlert from 'components/MDAlert'
import Footer from 'examples/Footer'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'

import { Skeleton, Stack, Tab, Tabs } from '@mui/material'
import beepSound from "assets/sounds/beep.mp3"
import errorSound from "assets/sounds/error.mp3"
import { useWebSocket } from 'context/WebSocketContext'
import GoogleMapBoardComponent from 'examples/Maps/board'
import moment from 'moment/moment'
import { useNavigate } from "react-router-dom"
import { toast } from 'react-toastify'
import CrudService from 'services/cruds-service'
import QRScanner from '../qrcodeScanner'
import DashboardDataTable from './datatable'
import { filtereRowData, processMapDeviceForAll, processDeviceType10, socketProcessDeviceType9 } from './misc'

function MapDeviceManagement() {
  const [data, setData] = useState([])
  const [tableData, setTableData] = useState([])
  const [notification, setNotification] = useState({
    value: false,
    text: '',
  })

  const [mapData, setMapData] = useState([])
  const [selectedDevice, setSelectedDevice] = useState()
  const [modalAlertOpen, setModalAlertOpen] = useState(false)
  const [alert, setAlert] = useState()
  const [loader, setLoader] = useState(false)
  const [qrModel, setQrModel] = useState(false)
  const [selectedDeviceType, setSelectedDeviceType] = useState(localStorage.getItem('rivio-device-dashboard-tab') ? Number(localStorage.getItem('rivio-device-dashboard-tab')) : 4)
  const [searchQuery, setSearchQuery] = useState('');
  const values = useRef([])
  const { assetTrackerData, levelMonitorData, holyKelData, jobState, tabletTelemetryData } = useWebSocket();
  const [externalMapDevice, setExternalMapDevice] = useState([])
  const filterRefLevelMonitor = useRef([])
  const filterRefGps = useRef([])
  const [filterData, setFilterData] = useState([])
  const [iconsList, setIconList] = useState([])
  const [badgesList, setBadgeList] = useState([])
  const [deviceExist, setDeviceExist] = useState({ 
    levelMonitor: 0,
    assetTracker: 0,
    gateway: 0,
    tablet: 0
   })
  const navigate = useNavigate()

  useEffect(() => {
    (async () => {
      try {
        const [iconsRes, badgesRes, deviceExistRes, externalDevicesRes] = await Promise.all([
          CrudService.getIcons(),
          CrudService.getBadges(),
          CrudService.checkDashboardDeviceExist(),
          CrudService.getDeviceByExternal(),
        ]);

        if (iconsRes?.data) setIconList(iconsRes.data);
        if (badgesRes?.data) setBadgeList(badgesRes.data);
        if (deviceExistRes) setDeviceExist(deviceExistRes);
        if (externalDevicesRes?.success) setExternalMapDevice(externalDevicesRes.data);

        fetchInternalDevices(selectedDeviceType);
      } catch (error) {
        console.error('Initialization error:', error);
      }
    })();
    document.title = `Rivio | Device Dashboard`
  }, [])

  function processGpsSingleData(device_value, geofence = null, linked_devices = null) {
    let timestamp = typeof device_value?.timestamp === 'number'
      ? device_value?.timestamp * 1000
      : device_value?.timestamp?.length == 10 ? Number(device_value?.timestamp) * 1000 : device_value?.timestamp;
    // const dateString = moment(timestamp);
    // let dur = moment.duration({
    //   from: device_value?.moment_status_duration,
    //   to: new Date()
    // });
    let shouldShowAddress = device_value?.reverse_geocoded_address ? device_value?.reverse_geocoded_address?.formatted_address : null
    let payload = {
      moment_status: device_value?.moment_status,
      speed: device_value?.convert_position_speed ? device_value?.convert_position_speed + ' m/h' : '',
      battery_level: device_value?.battery_level,
      external_powersource_status: device_value?.external_powersource_status ? 'True' : 'False',
      engine_ignition_status: device_value?.engine_ignition_status ? 'True' : 'False',
      fuel_level: device_value?.can_fuel_level ? device_value?.can_fuel_level + ' %' : '',
      rpm: device_value?.can_engine_rpm,
      lat: device_value?.position_latitude ||
        "Not Available",
      long: device_value?.position_longitude ||
        "Not Available",
      should_show_address: shouldShowAddress,
      moment_status_duration: device_value?.moment_status_duration,
      last_updated: timestamp,
      has_linked_device: linked_devices?.children?.length > 0 ? true : linked_devices?.parents?.length > 0,
      linked_devices: linked_devices?.children?.length > 0 ? linked_devices?.children : linked_devices?.parents,
    }

    if (geofence) {
      payload['location'] = geofence?.name ?? ''
      payload['color'] = geofence?.color ?? ''
    } else {
      payload['location'] = null
      payload['color'] = null
    }

    return payload;
  }

  const fetchInternalDevices = async (id) => {
    setLoader(true);
    const response = await CrudService.getInternalMapDevices(id);
    if (response?.data) {
      setData(response.data);
      values.current = response.data;
      let MapDataResponse;
      let filterRef = id == 8 ? filterRefGps : filterRefLevelMonitor
      if (filterRef.current.length > 0) {
        let device = response.data.filter((item) => filterRef.current.includes(item.id))
        MapDataResponse = processMapDeviceForAll(device, badgesList)
      } else {
        MapDataResponse = processMapDeviceForAll(response.data, badgesList)
      }
      setMapData(MapDataResponse)
    }
    setTimeout(() => {
      setLoader(false)
    }, 1000)
  }

  const newGpsDataChange = (value) => {
    let processed = processGpsSingleData(value.data, value?.geofence, value?.linked_devices)
    const updatedData = filterData.map(item =>
      item.id === value.device_id ? {
        ...item,
        ...processed
      } : item
    );
    setFilterData(updatedData)
  }

  const newLevelDataChange = async (id) => {
    let resp = await CrudService.getSingleMapDevices(id);
    if (resp.success) {
      let value = resp.data
      const updatedData = filterData.map(item =>
        item.device_id === value.device_id ? value : item
      );
      setFilterData(updatedData)
    }
  }

  useEffect(() => {
    if (assetTrackerData && selectedDeviceType == 8) {
      newGpsDataChange({
        device_id: assetTrackerData.device_id,
        data: assetTrackerData.data,
        geofence: assetTrackerData?.geofence,
        linked_devices: assetTrackerData?.linked_devices
      });
    }
  }, [assetTrackerData]);

  useEffect(() => {
    if (levelMonitorData && selectedDeviceType == 4) {
      newLevelDataChange(levelMonitorData.device_id)
    }
  }, [levelMonitorData])

  const newGatewayDeviceChange = (value) => {
    let processed = socketProcessDeviceType9(value.data, value.linked_devices)
    const updatedData = filterData.map(item =>
      item.id === value.device_id ? {
        ...item,
        ...processed
      } : item
    );
    setFilterData(updatedData)
  }

  useEffect(() => {
    if (holyKelData) {
      newGatewayDeviceChange(holyKelData)
    }
  }, [holyKelData])

  // Patch only the table row, like the other device types: changing mapData makes the
  // board re-fit bounds and drop the selected marker on every telemetry push.
  const newTabletTelemetryChange = (value) => {
    const raw = data.find(item => String(item.id) === String(value.device_id))
    if (!raw) return
    const merged = {
      ...raw,
      attributes: {
        ...raw.attributes,
        device_value: value.device_value ?? raw.attributes?.device_value,
        device_data: { ...(raw.attributes?.device_data || {}), ...(value.device_data || {}) },
      }
    }
    setFilterData(prev => prev.map(item =>
      String(item.id) === String(value.device_id) ? {
        ...item,
        ...processDeviceType10(merged, item.alert, item.entity),
        job_state: item.job_state
      } : item
    ))
  }

  useEffect(() => {
    if (tabletTelemetryData && selectedDeviceType == 10) {
      newTabletTelemetryChange(tabletTelemetryData)
    }
  }, [tabletTelemetryData])

  useEffect(() => {
    if (data.length > 0) {
      getNewRows(data).then(rows => {
        setTableData(rows);
      });
    } else {
      setTableData([])
    }
  }, [data]);

  const newJobState = (value) => {
    const updatedData = filterData.map(item =>
      item.id === value.device_id ? {
        ...item,
        job_state: value.to_state
      } : item
    );
    setFilterData(updatedData)
  }

  useEffect(() => {
    if(jobState){
      newJobState(jobState)
    }
  }, [jobState])

  useEffect(() => {
    let timer = null;
    if (notification.value === true) {
      timer = setTimeout(() => {
        setNotification({
          value: false,
          text: '',
        })
      }, 5000)
    }

    () => {
      if(timer) clearTimeout(timer)
    }
  }, [notification])

  useEffect(() => {
    const filteredRows = tableData.filter((row) => {
      // Convert searchQuery to lowercase for case-insensitive comparison
      const searchLower = searchQuery.toLowerCase();

      // Check if any property value in any cell of the row matches the search query
      return Object.values(row).some((cellValue) => {
        // If cellValue is an object, extract its string representation for comparison
        if (typeof cellValue === 'object' && cellValue !== null) {
          cellValue = Object.values(cellValue).join(' ');
        }
        // Check if the cellValue exists, is a string, and includes the search query (case-insensitive)
        return cellValue && typeof cellValue === 'string' && cellValue.toLowerCase().includes(searchLower);
      });
    });
    setFilterData(filteredRows)
    let ids = filteredRows.map((e) => e.id)
    let device = data.filter((item) => ids.includes(item.id))
    let MapDataResponse = processMapDeviceForAll(device, badgesList)
    setMapData(MapDataResponse)
  }, [searchQuery, tableData])

  const handleSelectedDeviceType = async (e, value) => {
    if (value != selectedDeviceType) {
      setSelectedDeviceType(value)
      localStorage.setItem('rivio-device-dashboard-tab', value)
      await fetchInternalDevices(value);
      setSelectedDevice(null)
    }
  }

  const resetSelectedeDevice = () => {
    let ids = filterData.map((e) => e.id)
    let device = data.filter((item) => ids.includes(item.id))
    let MapDataResponse = processMapDeviceForAll(device, badgesList)
    setMapData(MapDataResponse)
  }

  const deviceClickHandler = (id, type) => {
    setSelectedDevice(null)
    let device = data.find((item) => id.includes(item.id))
    if (device) {
      if (type) {
        device = { ...device, click_type: 'linked' }
      }
      setSelectedDevice(device)
    }
  }

  const showAlert = (e, id) => {
    e.stopPropagation();
    setModalAlertOpen(true)
    let selectedItem = data.find((item) => item.id === id)
    let alert = selectedItem?.attributes?.alerts?.length ? selectedItem?.attributes?.alerts[selectedItem?.attributes?.alerts.length - 1] : null
    setAlert(alert)
  }

  const hideAlert = () => {
    setModalAlertOpen(false)
  }

  const getNewRows = async (info) => {
    let updatedInfo = await filtereRowData(info, iconsList, badgesList)

    return updatedInfo;
  };

  const qrCodeResult = (textCode = '') => {
    try {
      let trimTextCode = textCode.trim()
      let findDevices = externalMapDevice.find((e) => e.external_device_id == trimTextCode)
      if (findDevices) {
        new Audio(beepSound).play();
        // navigate('/devices/view-device/'+findDevices[0].device_id)
        setQrModel(false)
        navigate('/devices/view-device/' + findDevices.device_id)
      } else {
        toast.info(`No result found for ${textCode}`)
        new Audio(errorSound).play();
      }
    } catch (error) {
      toast.error(JSON.stringify(error))
      setQrModel(false)
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {notification.value && (
        <MDAlert color="info" my="20px">
          <MDTypography variant="body2" color="white">
            {notification.text || ''}
          </MDTypography>
        </MDAlert>
      )}
      <MDBox>
        <MDBox>
          <Modal
            open={modalAlertOpen}
            onClose={hideAlert}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
          >
            <Card
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '30%', // Set the desired width here
                backgroundColor: 'white',
                p: 4,
                fontSize: '1rem !important'
              }}
            >
              <MDTypography className="text-base">
                Alert Details
              </MDTypography>
              <MDTypography variant="h6">
                Alert Type: {alert?.AlertType?.type_name ?? alert?.type_name}
              </MDTypography>
              <MDTypography variant="h6">Threshold: {alert?.threshold}</MDTypography>
              <MDTypography variant="h6">Current Value: {alert?.exceed_value}</MDTypography>
              <MDTypography variant="h6">Alert Created: {alert?.created_at ? moment(alert?.created_at).format('MMMM DD, YYYY h:mm:ss A') : ''}</MDTypography>
              <MDTypography variant="h6">
                Status: {alert?.status_type_id ? 'Active' : 'Inactive'}
              </MDTypography>
            </Card>
          </Modal>
          <Card>
            {
              !loader ?
                <GoogleMapBoardComponent
                  devices={mapData}
                  selectedRow={selectedDevice}
                  onSelectRow={setSelectedDevice}
                  resetSelectedeDevice={resetSelectedeDevice}
                  style={{ height: '600px' }} // Adjust the height here
                  deviceType={selectedDeviceType}
                /> :
                <Skeleton animation="wave" variant="rectangular" height={600} />
            }
            <MDBox display="flex" mt={1} mb={1} alignItems="center" justifyContent="space-between">
              <div></div>
              <Tabs value={selectedDeviceType} className="tabs-class" onChange={handleSelectedDeviceType} aria-label="basic tabs example" indicatorColor="secondary"
                textColor="inherit"
                variant="fullWidth"
                sx={{
                  "& .MuiTabs-flexContainer": {
                    gap: '10px'
                  }
                }}
              >
                {deviceExist.levelMonitor > 0 && <Tab label="Level Monitor" value={4} />}
                {deviceExist.assetTracker > 0 && <Tab label="Asset Tracker" value={8} />}
                {deviceExist.gateway > 0 && <Tab label="Gateway" value={9} />}
                {deviceExist.tablet > 0 && <Tab label="Tablet" value={10} />}
              </Tabs>
              <div></div>
            </MDBox>
            {
              !loader ?
                <DashboardDataTable
                  rowData={filterData}
                  selectedRows={[]}
                  setSelectedRows={(e) => deviceClickHandler(e)}
                  showAlert={showAlert}
                  selectedDeviceType={selectedDeviceType}
                  searchQuery={searchQuery}
                  onSearch={(val) => setSearchQuery(val)}
                  setSelectedLinked={(e) => deviceClickHandler(e, 'linked')}
                  qrModel={qrModel}
                  onChangeQrModel={(value) => setQrModel(value)}
                /> :
                <Stack spacing={0.4}>
                  <Skeleton variant="rectangular" height={60} />
                  <Skeleton variant="rectangular" height={30} />
                  <Skeleton variant="rectangular" height={30} />
                  <Skeleton variant="rectangular" height={30} />
                  <Skeleton variant="rectangular" height={30} />
                  <Skeleton variant="rectangular" height={30} />
                  <Skeleton variant="rectangular" height={30} />
                </Stack>
            }
            <Modal
              open={qrModel}
              onClose={() => setQrModel(!qrModel)}
              aria-labelledby="modal-title"
              aria-describedby="modal-description"
            >
              <Card
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: window.innerWidth < 600 ? "80%" : "21%", // Adjust width based on screen size
                  backgroundColor: "white",
                  boxShadow: 2,
                  p: 1,
                  maxHeight: "70vh", // Set max height to enable scrolling
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                <QRScanner qrCodeResult={qrCodeResult} />
              </Card>
            </Modal>
          </Card>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default MapDeviceManagement
